const RELOAD_FLAG = 'sol-chunk-reload';

export class ChunkTools {
  public static async load<T>(importFn: () => Promise<T>): Promise<T> {
    try {
      return await importFn();
    } catch (error: unknown) {
      ChunkTools.reloadOnChunkError(error);
      throw error;
    }
  }

  public static reloadOnChunkError(error: unknown): void {
    if (!ChunkTools.isChunkLoadError(error)) {
      return;
    }
    if (sessionStorage.getItem(RELOAD_FLAG)) {
      return;
    }
    sessionStorage.setItem(RELOAD_FLAG, '1');
    window.location.reload();
  }

  public static clearReloadFlag(): void {
    sessionStorage.removeItem(RELOAD_FLAG);
  }

  private static isChunkLoadError(error: unknown): boolean {
    if (error instanceof TypeError && error.message.includes('dynamically imported module')) {
      return true;
    }
    if (error instanceof Error && error.message.includes('Loading chunk')) {
      return true;
    }
    if (error instanceof Error && error.message.includes('ChunkLoadError')) {
      return true;
    }
    return false;
  }
}
